import type { TDatadogErrorLog } from 'utils/datadog/types'

export const CHART_EXPORT_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/hooks/use-chart-export',
  name: 'Chart export',
  message: 'Failed to export chart',
}
